export default "__VITE_ASSET__B6WXEQsY__"